module.exports = "https://cdn.thelire.com/ins/resource/coins_2.8c67de90e92b0320c088cad4250675c1.png";